module.exports = __webpack_public_path__ + "static/Image_550887760-fe754422b5b8acc49522478f3b218cf6.png";